import { CircularProgress } from "@mui/material";
import styles from "./bootSplash.module.css";

// Shown instead of the router while a persisted session is being verified at
// boot. Logged-out loads never see it (nothing to verify); verified loads
// skip straight to content. One clean transition instead of a stale-UI flash
// followed by a login bounce.
const BootSplash = () => (
  <div className={styles.splash} role="status" aria-label="Loading">
    <CircularProgress size={36} />
    <span className={styles.text}>Loading…</span>
  </div>
);

export default BootSplash;
